import { IInputCreate } from "Dashboard/scenes/Consumables/domain/IInputCreate";
import { useAppDispatch } from "hooks/hooks";
import {
  Controller,
  UseFormHandleSubmit,
  UseFormRegister,
  Control,
  FieldErrorsImpl,
  UseFormGetValues,
  UseFormSetValue
} from "react-hook-form";
import { toast } from "react-toastify";
import CategorySelect from "./CategorySelect";
import ConsumableItemSelectCreate from "./ConsumableItemSelectCreate";
import vladica from "../images/vladica.jpg";
import PartnerSimpleSelect from "Dashboard/scenes/Partners/components/PartnerSimpleSelect";
import UnitSelect from "Dashboard/components/UnitSelect";
import { consumablesService } from "Dashboard/scenes/Consumables/services/consumables.service";
import { addNewInput, setNewInputPopover } from "../input.slice";
import { styles } from "../../../../../../components/Popover/popoverSelectStyle";
import classes from "../../../../../../components/Popover/popover.module.scss";
import classesConsumables from "../../../popover.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
import { IOption } from "Dashboard/domain/IOption";
import ItemCodeSelect from "Dashboard/components/ItemCodeSelect";
import NumberInput from "Dashboard/components/NumberInput";
import DatePicker from "react-datepicker";
import { FormatDateIso } from "utils/dateUtils";

interface IProps {
  handleSubmit: UseFormHandleSubmit<IInputCreate>;
  setValue: UseFormSetValue<IInputCreate>;
  register: UseFormRegister<IInputCreate>;
  control: Control<IInputCreate, any>;
  getValues: UseFormGetValues<IInputCreate>;
  errors: Partial<FieldErrorsImpl<IInputCreate>>;
  reset: () => void;
  knownItemCodes: string[];
  setKnownItemCodes: React.Dispatch<React.SetStateAction<string[]>>;
  supplierValue: IOption | undefined;
  setSupplierValue: React.Dispatch<React.SetStateAction<IOption | undefined>>;
}

const NewInputPopover = (props: IProps) => {
  const dispatch = useAppDispatch();

  const {
    handleSubmit,
    setValue,
    register,
    control,
    getValues,
    errors,
    reset,
    knownItemCodes,
    setKnownItemCodes,
  } = props;

  const close = () => {
    dispatch(setNewInputPopover({ isOpen: false }));
    reset();
    props.setSupplierValue(undefined);
  };

  const onSubmit = async (data: IInputCreate) => {
    try {
      const response = await consumablesService.createInput(data);
      dispatch(addNewInput(response));
      close();
      toast.success("Materijal je uspešno dodat", {
        icon: <img
          style={{ width: "30px" }}
          src={vladica}
          alt="vladica.jpg" />,
      });
    } catch (err: any) {
      toast.error("Proverite da li ste uneli sve podatke");
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}
      className={`
        ${classesConsumables.newItemPopover}
        ${classes.basicPopoverView}
        ${classes.gPopoverInputs}
      `}
    >
      <div className={`${classes.basicPopover}`}>
        <div className={`${classes.row} ${classes.rowDir} ${classesConsumables.nameRow}`}>
          <div className={`${errors.itemId ? classes.itemError : ""} 
                ${classes.col} ${classes.colDir}`}>
            <label className={classes.aboveLabel}>naziv</label>
            <Controller
              name="itemId"
              control={control}
              defaultValue={undefined}
              rules={{
                required: true,
              }}
              render={({ field: { onChange } }) => (
                <ConsumableItemSelectCreate
                  value={getValues("itemId")}
                  setValue={setValue}
                  setKnownItemCodes={setKnownItemCodes}
                  category={"category"}
                  quantityUnit={"quantityUnit"}
                  error={errors.itemId}
                  customStyles={styles.customStyleClassic}
                  onChange={onChange}
                  preserveInput={true}
                />
              )}
            />
          </div>
        </div>

        <div className={`${classes.row} ${classes.rowDir}`}>
          <div className={`${errors.itemId ? classes.itemError : ""} 
                ${classes.col} ${classes.colDir}`}>
            <label className={classes.aboveLabel}>šifra artikla</label>
            <Controller
              name="itemCode"
              control={control}
              defaultValue={undefined}
              rules={{
                required: false,
              }}
              render={({ field: { onChange } }) => (
                <ItemCodeSelect
                  value={getValues("itemCode")}
                  knownItemCodes={knownItemCodes}
                  customStyles={styles.customStyleClassic}
                  error={errors.itemCode}
                  onChange={onChange}
                />
              )}
            />
          </div>

          <div className={`${errors.category ? classes.itemError : ""} 
                ${classes.col} ${classes.colDir}`}>
            <label className={classes.aboveLabel}>kategorija</label>
            <Controller
              name="category"
              control={control}
              defaultValue={undefined}
              rules={{
                required: true,
              }}
              render={({ field: { onChange } }) => (
                <CategorySelect
                  value={getValues("category")}
                  error={errors.category}
                  onChange={onChange}
                  customStyles={styles.customStyleClassic}
                  isClearable={false}
                />
              )}
            />
          </div>
        </div>


        <div className={`${classes.row} ${classes.rowDir}`}>
          <div
            className={`${errors.supplierPartnerId ? classes.itemError : ""} 
              ${classes.col} ${classes.colDir}`}>
            <label className={classes.aboveLabel}>dobavljač</label>
            <Controller
              name="supplierPartnerId"
              control={control}
              defaultValue={undefined}
              rules={{
                required: true,
              }}
              render={({ field: { onChange } }) => (
                <PartnerSimpleSelect
                  value={props.supplierValue}
                  setValue={props.setSupplierValue}
                  error={errors.supplierPartnerId}
                  customStyles={styles.customStyleClassic}
                  onChange={onChange}
                />
              )}
            />
          </div>

          <div className={`${classes.col} ${classes.colDir}`}>
            <label className={classes.aboveLabel}>br. otpremnice</label>
            <input type="text"
              className={`${classes.itemBorder} 
                ${errors.billOfLandingId ? classes.itemError : ""}`}
              {...register("billOfLandingId", { required: true })}
            />
          </div>
        </div>

        <div className={`${classes.row} ${classes.rowDir} ${classesConsumables.quantityUnitPriceRow}`}>
          <div className={`${classes.col} ${classes.colDir}`}>
            <label className={classes.aboveLabel}>kolicina</label>
            <Controller
              name="quantityAmountTotal"
              control={control}
              defaultValue={undefined}
              rules={{
                required: true,
              }}
              render={({ field: { onChange } }) => (
                <NumberInput
                  formatAs="quantity"
                  onChange={
                    (value: string, unmaskedValue: string, parsedValue: number) =>
                      onChange({ target: { value: unmaskedValue } })}
                  className={`${classes.itemBorder} 
                    ${errors.quantityAmountTotal ? classes.itemError : ""}`}
                />
              )}
            />
          </div>

          <div className={`${errors.quantityUnit ? classes.itemError : ""} 
                ${classes.col} ${classes.colDir}`}
          >
            <label className={classes.aboveLabel}>mera</label>
            <Controller
              name="quantityUnit"
              control={control}
              defaultValue={undefined}
              rules={{
                required: true,
              }}
              render={({ field: { onChange } }) => (
                <UnitSelect
                  value={getValues("quantityUnit")}
                  error={errors.quantityUnit}
                  customStyles={styles.customStyleClassic}
                  onChange={onChange}
                  isClearable={false}
                ></UnitSelect>
              )}
            />
          </div>

          <div
            className={`${classes.col} ${classes.colDir}`}
          >
            <label className={classes.aboveLabel}>cena po kom.</label>
            <Controller
              name="pricePerUnit"
              control={control}
              defaultValue={undefined}
              rules={{
                required: false,
              }}
              render={({ field: { onChange } }) => (
                <NumberInput
                  formatAs="rsd"
                  onChange={
                    (value: string, unmaskedValue: string, parsedValue: number) =>
                      onChange({ target: { value: unmaskedValue } })}
                  className={`${classes.itemBorder} 
                    ${errors.pricePerUnit ? classes.itemError : ""}`}
                />
              )}
            />
          </div>
        </div>

        <div className={`${classes.row} ${classes.rowDir}`}>
          <div className={`${classes.col} ${classes.colDir}`}>
            <label className={classes.aboveLabel}>datum</label>
            <Controller
              control={control}
              name="date"
              defaultValue={FormatDateIso(new Date())}
              rules={{ required: false, }}
              render={({ field: { onChange, value } }) => (
                <div>
                  <DatePicker
                    onChange={(date) =>
                      onChange(date ? FormatDateIso(date) : undefined)
                    }
                    dateFormat="dd.MM.yyyy"
                    showMonthDropdown
                    showYearDropdown
                    selected={value ? new Date(value) : null}
                    className={`${classes.dateItem} ${classes.itemBorder}
                        ${errors.date ? classes.itemError : ""}`}
                  />
                </div>
              )}
            />
          </div>

          <div className={`${classes.col} ${classes.colDir}`}>
            <label className={classes.aboveLabel}>xxx</label>
            <input type="checkbox"
              className={`${classes.itemBorder} ${errors.xxx ? classes.itemError : ""}`}
              {...register("xxx")}
            />
          </div>

          <div className={`${classes.buttons} 
                ${classes.col} ${classes.colDir}`}>
            <button className={classes.iconButton} type="submit">
              <FontAwesomeIcon
                icon={faLongArrowAltDown}
                className={classes.icon} />
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default NewInputPopover;
